module.exports = __webpack_public_path__ + "static/img/smartstation52.65a836a3.png";